'use-client'
import { Box } from '@mui/material'
import React, { Suspense } from 'react'
import Swap from '@/components/Swap/Swap'
import { SwapSkeleton } from '../common/Audio'

const SwapMain: React.FC = () => {
  return (
    <>
      <Box>
        <Suspense fallback={
          <SwapSkeleton />
        }
        >
          <Swap />
        </Suspense>
      </Box>
    </>
  )
}
export default SwapMain
